import React, { Fragment, useState, useEffect } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'ReduxStore/store';

import { GetAllKids } from 'ReduxStore/children/Action';
import { chdir } from 'process';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			'& > *': {
				margin: 0,
			},
		},
		input: {
			display: 'none',
		},
		button: {
			background: '#fb6326',
			color: 'white',
		},
		iconButton: {
			background: '#fb6326',
			padding: 6,
			margin: '0 .6rem',
			borderRadius: 2,
			color: 'white',
		},
		listItems: {
			listStyleType: 'none',
			backgroundColor: 'white',
			zIndex: 100,
			padding: 0,
			borderRadius: '4px',
			margin: '0.5rem 0',
			position: 'absolute',
			width: '90px',
		},
		item: {
			zIndex: 100,
			color: 'black',
			cursor: 'pointer',
			padding: '0.4rem 0.5rem',
			'&:hover': { backgroundColor: '#eae7e7' },
		},
	}),
);
interface NameHolderParams {
	setName?: any;
}
const NameHolder = ({ setName }: NameHolderParams) => {
	const classes = useStyles();
	const currentName = localStorage.getItem('currentChild');
	const currentChildId = localStorage.getItem('currentChildId');
	const children = useSelector((state: RootState) => state.children.children);
	const dispatch = useDispatch();
	useEffect(() => {
		const getParentChild = async () => await GetAllKids()(dispatch);
		getParentChild();
	}, []);

	const [open, setOpen] = useState(false);
	const handleDropDownOpen = () => {
		setOpen(!open);
	};
	const handleKidChange = (name: string, id: number) => {
		// localStorage.removeItem('currentChild');
		localStorage.setItem('currentChild', name);
		localStorage.setItem('currentChildId', `${id}`);
		const setNamed = localStorage.getItem('currentChild');
		setName && setName(setNamed);
		setOpen(!open);
		window.location.reload();
	};
	return (
		<Fragment>
			<div className={classes.root}>
				<Button variant="contained" className={classes.button} component="span">
					{currentName}
				</Button>
				<IconButton
					onClick={handleDropDownOpen}
					className={classes.iconButton}
					aria-label="arrow dropdown icon"
				>
					{/* onclick   */}
					<ArrowDropDownIcon />
				</IconButton>

				{open && (
					<ul className={classes.listItems}>
						{children &&
							children.map(child => (
								<li
									key={child.id}
									onClick={() => handleKidChange(child.fullName, child.id)}
									className={classes.item}
								>
									{currentName != child.fullName && child.fullName}
								</li>
							))}
					</ul>
				)}
			</div>
		</Fragment>
	);
};

export default NameHolder;
